<!-- Div .content -->
<div class="content">
  <!-- Div .content-panel -->
  <div class="content-panel">
    <h2 translate>page.controles.manquements.title</h2>

    <!-- Formulaire de recherche des manquements -->
<form [formGroup]="formSearchManquements" #form="ngForm" (ngSubmit)="onSubmit()" class="search-form" novalidate>
  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body py-3">
      <div class="row g-3 align-items-end">

        <div class="col-12 col-lg-4">
          <label for="nature" class="form-label" translate>
            page.controles.manquements.form.nature
          </label>
          <select
            id="nature"
            formControlName="nature"
            class="form-select"
            [ngClass]="{ 'is-invalid': form.submitted && formSearchManquements.get('nature')?.invalid }"
          >
            <option [ngValue]="null">Sélectionner</option>
            <option *ngFor="let nature of refNatures" [ngValue]="nature">
              {{ nature.libelle }}
            </option>
          </select>
        </div>

        <div class="col-12 col-lg-4">
          <label for="numeroManquement" class="form-label" translate>
            page.controles.manquements.form.numeroManquement
          </label>
          <input
            type="text"
            id="numeroManquement"
            formControlName="numeroManquement"
            class="form-control"
          />
        </div>

        <div class="col-12 col-lg-4 d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            (click)="showAdvancedFilters = !showAdvancedFilters"
          >
            {{ showAdvancedFilters ? 'Masquer les filtres' : 'Filtres avancés' }}
          </button>

          <button type="submit" class="btn btn-primary w-100">
            Rechercher
          </button>
        </div>
      </div>

      <div class="active-filters mt-3" *ngIf="hasActiveFiltersManquements()">

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('nature')?.value as selectedNature">
          Nature : {{ selectedNature.libelle }}
          <button type="button" class="chip-close" (click)="clearManquementField('nature')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('statuts')?.value?.length">
          Statuts : {{ getLibelles(formSearchManquements.get('statuts')?.value, 'libelle') }}
          <button type="button" class="chip-close" (click)="clearManquementField('statuts')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('debut')?.value">
          Date début renseignée
          <button type="button" class="chip-close" (click)="clearManquementField('debut')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('fin')?.value">
          Date fin renseignée
          <button type="button" class="chip-close" (click)="clearManquementField('fin')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('agents')?.value?.length">
          Agents : {{ getLibelles(formSearchManquements.get('agents')?.value, 'nomComplet') }}
          <button type="button" class="chip-close" (click)="clearManquementField('agents')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('numeroManquement')?.value">
          N° manquement : {{ formSearchManquements.get('numeroManquement')?.value }}
          <button type="button" class="chip-close" (click)="clearManquementField('numeroManquement')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('numeroControle')?.value">
          N° contrôle : {{ formSearchManquements.get('numeroControle')?.value }}
          <button type="button" class="chip-close" (click)="clearManquementField('numeroControle')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchManquements.get('numeroCVI')?.value">
          CVI : {{ formSearchManquements.get('numeroCVI')?.value }}
          <button type="button" class="chip-close" (click)="clearManquementField('numeroCVI')">×</button>
        </span>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="resetManquementsForm()"
        >
          Tout effacer
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showAdvancedFilters">
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body py-3">
        <div class="row g-3">

          <div class="col-12 col-md-6 col-xl-3">
            <label for="statuts" class="form-label" translate>
              page.controles.manquements.form.statut
            </label>
            <app-multiselect
              id="statuts"
              controlName="statuts"
              [items]="refStatuts"
              bindLabel="libelle"
              maxWidth="initial">
            </app-multiselect>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="debut" class="form-label" translate>
              page.controles.manquements.form.constatEntre
            </label>
            <div class="input-group">
              <input
                id="debut"
                class="form-control"
                formControlName="debut"
                ngbDatepicker
                #datePickerDebut="ngbDatepicker"
              />
              <button type="button" (click)="datePickerDebut.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="fin" class="form-label" translate>
              page.controles.manquements.form.et
            </label>
            <div class="input-group">
              <input
                id="fin"
                class="form-control"
                formControlName="fin"
                ngbDatepicker
                #datePickerFin="ngbDatepicker"
              />
              <button type="button" (click)="datePickerFin.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="agents" class="form-label" translate>
              page.controles.manquements.form.agent
            </label>
            <app-multiselect
              id="agents"
              controlName="agents"
              [items]="refAgents"
              bindLabel="nomComplet"
              maxWidth="initial">
            </app-multiselect>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="numeroControle" class="form-label" translate>
              page.controles.manquements.form.numeroControle
            </label>
            <input
              type="text"
              id="numeroControle"
              formControlName="numeroControle"
              class="form-control"
            />
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="numeroCVI" class="form-label" translate>
              page.controles.manquements.form.numeroCVI
            </label>
            <input
              type="text"
              id="numeroCVI"
              formControlName="numeroCVI"
              class="form-control"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</form>
    <!-- Fin formulaire de recherche des manquements -->

    <ng-container *ngIf="pagination?.response?.length > 0; else aucunResultat">
      <table class="table" aria-label="Liste des manquements">
        <thead>
          <th translate>page.controles.manquements.table.numeroManquement</th>
          <th translate>page.controles.manquements.table.raisonSociale</th>
          <th translate>page.controles.manquements.table.nature</th>
          <th translate>page.controles.manquements.table.dateConstat</th>
          <th translate>page.controles.manquements.table.agent</th>
          <th translate>page.controles.manquements.table.cdc</th>
          <th translate>page.controles.manquements.table.statut</th>
          <th></th>
          <th></th>
        </thead>

        <tbody>
          <tr *ngFor="let manquement of pagination.response">
            <td>{{ manquement.numero }}</td>
            <td>{{ manquement.operateur?.raisonSociale }}<br/>{{ manquement.cvi }}</td>
            <td>{{ manquement.nature?.libelle }}</td>
            <td>{{ manquement.dateConstat | date:'dd/MM/yyyy' }}</td>
            <td>{{ manquement.agent?.nomComplet }}</td>
            <td>{{ manquement.produit?.libelle }}</td>
            <td>{{ manquement.statut?.libelle }}</td>
            <td>
              <button type="button" class="btn btn-light" (click)="onEdit(manquement)" *hasRole="'DECLARATION_CONTROLE_ECRITURE'">
                <fa-icon icon="pen" title="Modifier"></fa-icon>
              </button>
            </td>
            <td>
              <button style="margin-left: 1em;" type="button" class="btn btn-outline-secondary btn-add"
              (click)="telechargerDocument(manquement)">
              <fa-icon icon="download" class="primary-icon" title="Télécharger le document"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <app-pagination-bar [pagination]="pagination.pagination"></app-pagination-bar>
    </ng-container>
  </div>
  <!-- Fin div .content-panel -->
</div>
<!-- Fin div .content -->

<ng-template #aucunResultat>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon>
    page.controles.manquements.form.aucunManquement
  </div>
</ng-template>

